import React, { useMemo } from 'react'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Container, useMediaQuery } from '@material-ui/core';
import FlexView from 'react-flexview/lib';
import { ActivePoliciesList } from './ActivePolicies/ActivePoliciesList';
import { PolicyManagementContextStore } from '../../context/PolicyManagementContext';
import { useRouteMatch, Route, useLocation, useHistory } from 'react-router-dom';
import { PolicyCardSkeleton } from './PolicyCardSkeleton';
import { isBrowser } from 'react-device-detect';
import { SessionContextStore } from "../../context/SessionContext";
import { BlueGrayBox } from "../Core/BlueGrayBox";
import { SessionService } from "../../services/SessionService";

export const PolicyManagementLayout = () => {
    const myPoliciesContext = React.useContext(PolicyManagementContextStore)
    const sessionContext = React.useContext(SessionContextStore)
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const [tabIndex, setTabIndex] = React.useState(0);
    const location = useLocation()
    const history = useHistory()
    let { path, url } = useRouteMatch();
    const currentPolicies = useMemo(() => myPoliciesContext.active_policies.concat(myPoliciesContext.scheduled_policies), [myPoliciesContext.active_policies, myPoliciesContext.scheduled_policies])
    const handleTabChange = (event, newValue) => {
        if(location.pathname != path) {
            history.replace(path)
        }        
        setTabIndex(newValue);
    };
    
    React.useEffect(() => {
        if(!myPoliciesContext.loading_policies) {
            if(tabIndex == 0 && myPoliciesContext.active_policies.length == 0) {
                if(myPoliciesContext.previous_policies.length > 0)
                    handleTabChange(undefined, 1)
            }
            if (location.search){
                history.push({pathname: location.pathname, search: location.search}, {open_details: true})
            }
        }

    }, [myPoliciesContext.loading_policies])

    const showTabs = isBrowser || location.pathname == path

    return (
        <Container maxWidth="lg" className="margin-top-basic">
            <FlexView hAlignContent={'center'} column={isMobile}>
                {showTabs && <React.Fragment>
                    {isMobile && <div className="text-title textcenter black bold margin-top-basic">Policy management</div>}
                    <Tabs 
                        orientation={isMobile ? "horizontal" : "vertical"}
                        variant="scrollable"
                        value={tabIndex}
                        indicatorColor={'primary'}
                        textColor="primary"
                        onChange={handleTabChange}>
                            <Tab label="Current" />
                            <Tab label="History" />
                    </Tabs>
                </React.Fragment>}

                <div className={`full-width ${isMobile ? 'margin-x-0' : 'margin-left-basic margin-right-basic'}`}>

                    {!isMobile && 
                        <FlexView vAlignContent={'bottom'}>
                            <div className="text-title black bold margin-top-basic margin-bottom-basic">Policy Management</div>
                            { SessionService.isBroker() && <div className='margin-top-basic text-tiny margin-left-6'><BlueGrayBox>{sessionContext.user.email}</BlueGrayBox></div> }
                            { SessionService.isBroker() && <div className='margin-top-basic text-tiny margin-left-6'><BlueGrayBox>{sessionContext.user.phoneNumber} </BlueGrayBox></div> }
                            { SessionService.isBroker() && <div className='margin-top-basic text-tiny margin-left-6'><BlueGrayBox>{sessionContext.user.firstName} {sessionContext.user.lastName} </BlueGrayBox></div> }
                        </FlexView> 
                    }
                        <Route exact path={path}>
                            {tabIndex == 0 && <Container maxWidth="lg">
                                {myPoliciesContext.loading_policies ? <FlexView column={isMobile}>
                                        <PolicyCardSkeleton />
                                        <PolicyCardSkeleton />
                                </FlexView> : <ActivePoliciesList policies={currentPolicies} />}
                            </Container>}
                            {tabIndex == 1 && <Container maxWidth="lg">
                                {myPoliciesContext.loading_policies ? <PolicyCardSkeleton /> : <ActivePoliciesList policies={myPoliciesContext.previous_policies}/>}
                            </Container> }
                        </Route>
                </div>

            </FlexView>
        </Container>
    )
}